<lib-validation-problems [saving$]="saving$"></lib-validation-problems>
<lib-order-search-criteria 
    [shouldDisplayExactSimilar]="shouldDisplayExactSimilar"
    [shouldDisplaySearchFromDate]="shouldDisplaySearchFromDate"></lib-order-search-criteria>